import {
    RECEIVE_DATA,
    REQUEST_DATA,
} from './RetirementAssetsChartActions';

const
    INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
    const {
        type,
    } = action;

    switch (type) {
        case REQUEST_DATA:
            return {
                ...state,
                [action.clientId]: {
                    ...(state[action.clientId] || {}),
                    loading: true,
                    showLoading: action.showLoading,
                },
            };
        case RECEIVE_DATA:
            return {
                ...state,
                [action.clientId]: {
                    ...(state[action.clientId] || {}),
                    responseData: action.data,
                    loading: false,
                    showLoading: false,
                },
            };
        default:
            return state;
    };
};
